import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';

import { DataService } from '../../../services/data.service';
import { FilterBoxService } from '../../../services/filter-box.service';
import { AuthService } from '../../../services/auth.service';

import { GenericFilterParameter } from '../../../models/generic-comunication-cmp';
import { GenericDataSource } from '../../../models/generic-data-source';

@Component({
  selector: 'app-filter-box-generic',
  templateUrl: './filter-box-generic.component.html',
  styleUrls: ['./filter-box-generic.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterBoxGenericComponent implements OnInit {
    @ViewChild('filterAnagrafica') filterAnagraficaComponent: any;
    @ViewChild('filterPratiche') filterPraticheComponent: any;

    @ViewChild('filterStatisticheGenerali') filterStatisticheGeneraliComponent: any;
    @ViewChild('filterStatisticheDettagli') filterStatisticheDettagliComponent: any;
    @ViewChild('filterGestioneUtentiComponent') filterGestioneUtentiComponent: any;

    @Input() parametriString: string = "{}";
    @Output() filterBoxGenericEmitter = new EventEmitter();

    parametri: GenericFilterParameter = null;
    filterMap = null;

    numFiltered: number = null;
    dataArrayOutput: any[];
    dataSource: GenericDataSource;
    searchField$ = new BehaviorSubject<any>(this.filterMap);

    constructor(private cdr: ChangeDetectorRef, private dataService: DataService, private filterBoxService: FilterBoxService, private authService: AuthService) {
    }

    ngOnInit() {
        //console.log("filterBoxService", this.filterBoxService);
        this.dataSource = new GenericDataSource(this.filterBoxService);
        this.resetFilters();
    }

	ngOnChanges(changes: any){
		//console.log('CHANGE FILTER-BOX', changes);
        if(changes.dataArraySource){
            //console.log('CHANGE FILTER-BOX', changes.dataArraySource);
            this.resetFilters();
        }
		if(changes.filterMap){
            //console.log('CHANGE FILTER-BOX filterMap', this.filterMap);
            this.resetFilters();
		}
        if(changes.parametriString){
            this.updateParametri();
        }
	}

	updateParametri(){
        //console.log('CHANGE FILTER-BOX PARAMETRISTRING', this.parametriString);
        if(this.parametriString){
            this.parametri = new GenericFilterParameter();
            this.parametri = this.parametri.generateParametriFromString(this.parametriString);
            this.find();
        }
        //console.log('CMP|FILTER-GENERIC - CHANGE FILTER-BOX PARAMETRI', this.parametri);
	}

    isEmpty(value: any) {
        let isEmptyResult = true;
        if(value !== null){
            let type = typeof value;
            switch(type){
                case 'object':
                    isEmptyResult = !(value.length > 0);
                    break;
                case 'string':
                    isEmptyResult = !value.trim();
                    break;
                case 'undefined':
                    break;
                default:
                    console.log("type", type);
            }
        }
        return isEmptyResult;
    }

    emptyFilterMap(){
        //console.log("emptyFilterMap", this.filterMap);
        let emptyFilterMapResult = true;
        if(this.filterMap){
            this.filterMap.forEach((filterMap: boolean, key: string) => {
                let filterValue = null;
                filterValue = filterMap["value"];
                emptyFilterMapResult = emptyFilterMapResult && this.isEmpty(filterValue);
            });
        }
        this.cdr.markForCheck();
        return emptyFilterMapResult;
    }

    emptyExternCommands(){
        let result = true;
        if(this.parametri.externCommandsArray && this.parametri.externCommandsArray.length){
            result = false;
        }
        //console.log("emptyExternCommands result", result, this.parametri.externCommandsArray, this.parametri.externCommandsArray.length);
        return result;
    }

    callbackExternCommands(dataCommand: any){
        let eventObject = {
            "type": "action",
            "data": dataCommand,
        };
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    groupByCommand(groupByKey: any, groupByType: any){
        let eventObject = {
            "type": "groupBy",
            "data": {
                key: groupByKey,
                value: groupByType,
            },
        };
        console.log("groupBy", eventObject);
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    updateFiltersMap(){
        this.find();
        let trovato = (this.filterMap.get('rapportoStileRadio')) ? this.filterMap.get('rapportoStileRadio') : null;
        //console.log("FILTER-BOX rapportoStileRadio trovato", trovato);
        if(trovato){
            this.groupByCommand('FILTER-BOX|rapportoStileRadio', trovato.value);
        }
        //console.log("FILTER-BOX|updateFiltersMap", this.filterMap);
    }

    idStatoChanged(idStatoAttuale: number){
        let idStatoLocal = (idStatoAttuale) ? idStatoAttuale : null;
        let eventObject = {
            "type": "idStatoSelected",
            "data": idStatoLocal,
        };
        //console.log("FILTER-BOX|idStatoSelected", eventObject);
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    find(){
        this.numFiltered = null;
        //console.log('find pre PARAMETRI', this.parametri, this.filterMap);
        if(this.dataSource){
            this.dataSource.loadResults(this.parametri.dataArraySource, this.filterMap);
            this.dataSource.connect(null).subscribe(
                results => {
                    this.dataArrayOutput = results;
                    if(this.dataArrayOutput){
                        this.numFiltered = this.dataArrayOutput.length;
                        let eventObject = {
                            "type": "filterResult",
                            "filterMap": this.filterMap,
                            "data": this.dataArrayOutput
                        };
                        //console.log('find eventObject', eventObject);
                        this.filterBoxGenericEmitter.emit(eventObject);
                    }
                }
            );
        }
    }

    manageEventFilterBox($event){
        //console.log("CMP|FILTER-BOX - manageEventFilterBox", $event);
        if($event){
			switch($event.type){
				case 'updateFiltersMap':
                    this.filterMap = $event.data;
                    this.updateFiltersMap();
					break;
				case 'idStatoSelected':
					let idStatoAttuale = $event.data;
                    this.idStatoChanged(idStatoAttuale);
					break;
				default:
					console.log("FILTER-BOX|type non riconosciuto!");
			}
		}
    }

    resetFilters(){
        //console.log("filter-box resetFilters");
        if(this.filterAnagraficaComponent){
            this.filterMap = this.filterAnagraficaComponent.resetFilters();
        }
        if(this.filterPraticheComponent){
            this.filterMap = this.filterPraticheComponent.resetFilters();
        }
        if(this.filterStatisticheGeneraliComponent){
            this.filterMap = this.filterStatisticheGeneraliComponent.resetFilters();
        }
        if(this.filterStatisticheDettagliComponent){
            this.filterMap = this.filterStatisticheDettagliComponent.resetFilters();
        }
        if(this.filterGestioneUtentiComponent){
            this.filterMap = this.filterGestioneUtentiComponent.resetFilters();
        }

        this.find();
    }

    ngOnDestroy() {
    }
}
